<template>
  <div>
    <vxe-toolbar
      id="toolbarId_cu_invoice"
      :custom="{storage: true}"
      export
    >
      <template v-slot:buttons>
        <el-button
          type="primary"
          @click="requestclick()"
        >
          确定索取发票
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      :radio-config="{highlight: true}"
      row-id="id"
      height="500"
      :loading="loading"
      :data="tableData"
    >
      <vxe-table-column
        type="radio"
        width="60"
      />
      <vxe-table-column
        field="invoiceTitle"
        title="发票抬头"
        min-width="200"
        sortable
      />
      <vxe-table-column
        field="taxRegistrationNumber"
        title="税务登记证号"
        min-width="150"
        sortable
      />
      <vxe-table-column
        field="bankName"
        title="基本开户银行"
        min-width="200"
        sortable
      />
      <vxe-table-column
        field="accountNumber"
        title="基本开户账号"
        min-width="150"
        sortable
      />
      <vxe-table-column
        field="registeredAddress"
        title="注册场所地址"
        min-width="150"
        sortable
      />
     
      <vxe-table-column
        field="registeredFixedPhone"
        title="注册固定电话"
        min-width="200"
        sortable
      />
      <!-- <vxe-table-column
        field="type"
        title="开票方式"
        :formatter="formatterStatus"
        min-width="150"
        sortable
      /> -->
    </vxe-table>
  </div>
</template>
<script>
import {getInvoiceMessageJinChang,obtainShipperInvoiceJinChang } from "@/api/invoice";

export default {
  data() {
    return {
      tableData: [],
      
      loading: false,
      Freightamount: "",
      Invoiceamount: "",
      Pagingconf: [],
      listQuery: {
        pageNum: 1,
        pageSize: 1000,
        total: 0
      },
      type2: [],
      object: {
        invoiceMessageCode: "",
        detailCodes: ""
      },
       statusOptions: [
        { label: "申请开票", value: 0 },
        { label: "已取消", value: 1 },
        { label: "已开票", value: 2 }
      ],
    };
  },
  created() {},
  methods: {
    invoicelist(type,shipperCode,code) {
      this.loading = true;
      this.object.detailCodes = code
      getInvoiceMessageJinChang({type:type,userCode:shipperCode}).then(response => {
         this.tableData = response.data.records|| [];
         response.data.total? this.Pagingconf = [20, 30, 50, 100, response.data.total] : this.Pagingconf = [20, 30, 50, 100];
         this.loading = false;
      });
    },
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "现付开票";
        case 1:
          return "到付开票";
        case 2:
          return "代付开票";
      }
    },
    requestclick() {
      this.object.invoiceMessageCode = "";
      const Code = this.$refs.xTable.getRadioRecord();
      if (Code == null) {
        this.$message({ message: "请选择发票抬头", type: "warning" });
      } else {
        this.object.invoiceMessageCode = Code.code;
        const rLoading = this.openLoading();
        obtainShipperInvoiceJinChang(this.object).then(response => {
          if (response.status == 0) {
              rLoading.close();
              this.$message({
                message: response.msg,
                type: "success"
              });
          }
          this.$emit("event1");
        });
      }
    },
  }
};
</script>

<style>


</style>
